const API_URL = process.env.REACT_APP_API_URL || window.API_URL;

export function getImageUrl(imageKey){
    if (!imageKey) {
        return null;
    }
    return `${API_URL}/static/${imageKey}`
}